import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetReporteAperturaLinea = () => {
  const api = useApi();

  const mutate = async (params) => {
    const { data } = await api.get(`/cuestionarios-respuestas/respuestas/almacen/${params?.almacen}?startDate=${params?.startDate}&endDate=${params?.endDate}`);
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    getReporteAperturaLineaMutation: mutation.mutate,
  };
};

export const DownloadExcelAperturaLinea = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/cuestionarios-respuestas/respuestas/almacen/${params?.almacen}/download-excel?startDate=${params?.inicio}&endDate=${params?.final}`, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
      responseType: 'blob', // Indicamos que esperamos un archivo binario (blob)
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    getDownloadExcelAperturaLinea: mutation.mutate,
  };
}
